import React, { useEffect } from "react";
import { useSEO } from "../../context/SEOContext";
import { useTranslation } from "react-i18next";
const PrivacyPolicy = () => {
  const { t } = useTranslation();
  const setSeo = useSEO();
  useEffect(() => {
    setSeo({
      title: t("privacyPolicy.meta.title"),
      description: t("privacyPolicy.meta.description"),
      keywords: t("privacyPolicy.meta.keywords"),
      favicon: "/faviconnew.png", // ✅ burada favicon tanımlandı
    });
  }, [setSeo, t]);
  return (
    <div className="container py-5">
      <div className="row">
        <div className="col-lg-12 mb-5 text-center">
          <h4 className="fw-light">{t("PrivacyPolicyTitle")}</h4>
        </div>
        <div className="col-lg-12">
          <p>{t("PrivacyIntro")}</p>
          {/* <p>
            <a href="https://www.privacypolicytemplate.net">
              Privacy Policy Template Generator
            </a>
            .
          </p> */}
          <p>{t("PrivacyTermsNote")}</p>
          <h4>{t("InfoCollectionTitle")}</h4>
          <p>{t("InfoCollection")}</p>
          <h4>{t("LogDataTitle")}</h4>
          <p>{t("LogData")}</p>
          <h4>{t("CookiesTitle")}</h4>
          <p>
            {t("Cookies")}
            {t("CookiesMoreInfo")}
            {/* <a href="https://www.generateprivacypolicy.com/#cookies">
              "Cookies" article from the Privacy Policy Generator
            </a> */}
            .
          </p>
          <h4>{t("ServiceProvidersTitle")}</h4>
          <p>{t("ServiceProviders")}</p>
          <ul>
            <li>{t("ServiceProvidersDesc")}</li>
            <li>{t("ServiceProvidersDesc2")}</li>
            <li>{t("ServiceProvidersDesc3")}</li>
            <li>{t("ServiceProvidersDesc4")}</li>
          </ul>
          <p>{t("ThirdPartyAccess")}</p>
          <h4 className="mb-3">{t("SecurityTitle")}</h4>
          <p>{t("Security")}</p>
          <h4 className="mb-3">{t("LinksTitle")}</h4>
          <p>
            {t("ExternalLinks")} <br />
            {t("ChildPrivacy")}
            {/* Our Service may contain links to other sites. If you click on a
            third-party link, you will be directed to that site. Note that these
            external sites are not operated by us. Therefore, we strongly advise
            you to review the Privacy Policy of these websites. We have no
            control over, and assume no responsibility for the content, privacy
            policies, or practices of any third-party sites or services.
            Children's Privacy Our Services do not address anyone under the age
            of 13. We do not knowingly collect personal identifiable information
            from children under 13. In the case we discover that a child under
            13 has provided us with personal information, we immediately delete
            this from our servers. If you are a parent or guardian and you are
            aware that your child has provided us with personal information,
            please contact us so that we will be able to do necessary actions. */}
          </p>
          <h4 className="mb-3"> {t("ChangesTitle")}</h4>
          <p>
            {t("PolicyChanges")}
            {/* We may update our Privacy Policy from time to time. Thus, we advise
            you to review this page periodically for any changes. We will notify
            you of any changes by posting the new Privacy Policy on this page.
            These changes are effective immediately, after they are posted on
            this page. */}
          </p>
          <h4 className="mb-3">{t("ContactUsTitle")}</h4>
          <p>
            {t("ContactUs")}
            {/* If you have any questions or suggestions about our Privacy Policy,
            do not hesitate to contact us. */}
          </p>
          <h4 className="mb-3">{t("AddressTitle")}</h4>
          <p>{t("AddressWeb")}</p>
          <h4 className="mb-3">{t("MobileTitle")}</h4>
          <p>
            <a href="tel:+905365049119">+90 536 504 91 19</a>
          </p>
          <h4 className="mb-3">{t("EmailTitleP")}</h4>
          <a href="emailto:customer.support@mukemel.com">{t("EmailP")}</a>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
